import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EntityCrudState } from '@homeleite/common-components';
import {
    User,
    UsersRepository,
    ControllerUser,
    ControllerSummary,
    Controller
} from '@homeleite/domain';

import { Observable } from 'rxjs';

import {
    UserDialogData,
    UsersFormDialogComponent
} from '../../../users/users-form-dialog/users-form-dialog.component';

@Component({
    selector: 'app-controller-details-users',
    templateUrl: './controller-details-users.component.html',
    styleUrls: ['./controller-details-users.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControllerDetailsUsersComponent {
    @Input() entity: Controller;
    @Input() associatedUsers$: Observable<User[]>;
    @Output() usersChanged = new EventEmitter<void>();

    constructor(
        public dialog: MatDialog,
        private repository: UsersRepository,
        private snackBar: MatSnackBar
    ) {}

    userInitials(user: User): string {
        const a = (user?.firstName || '').trim();
        const b = (user?.lastName || '').trim();
        if (a && b) return (a[0] + b[0]).toUpperCase();
        const s = (a || b || user?.email || '?').trim();
        return s.slice(0, 2).toUpperCase();
    }

    openCreateUserDialog(): void {
        const dialogRef = this.dialog.open<UsersFormDialogComponent, UserDialogData>(
            UsersFormDialogComponent,
            {
                width: '450px',
                disableClose: true,
                data: {
                    entity: new ControllerUser(
                        undefined,
                        '',
                        '',
                        '',
                        '',
                        '',
                        new ControllerSummary(this.entity.id, this.entity.name)
                    ),
                    state: EntityCrudState.INSERT
                }
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.repository.insert(result.entity).subscribe({
                    next: () => {
                        this.snackBar.open('Usuário criado com sucesso!', 'Fechar', {
                            duration: 3000
                        });
                        this.usersChanged.emit();
                    },
                    error: (err: HttpErrorResponse) => {
                        if (err.status === 409) {
                            this.snackBar.open(
                                'Erro: O login informado já está em uso.',
                                'Fechar',
                                {
                                    duration: 4000
                                }
                            );
                        } else {
                            this.snackBar.open('Erro ao criar usuário.', 'Fechar', {
                                duration: 3000
                            });
                        }
                    }
                });
            }
        });
    }

    openEditUserDialog(userToEdit: User): void {
        const dialogRef = this.dialog.open<UsersFormDialogComponent, UserDialogData>(
            UsersFormDialogComponent,
            {
                width: '450px',
                disableClose: true,
                data: {
                    entity: userToEdit,
                    state: EntityCrudState.EDIT
                }
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.repository.update(result.entity).subscribe({
                    next: () => {
                        this.snackBar.open('Usuário atualizado com sucesso!', 'Fechar', {
                            duration: 3000
                        });
                        this.usersChanged.emit();
                    },
                    error: (err: HttpErrorResponse) => {
                        if (err.status === 409) {
                            this.snackBar.open(
                                'Erro: O login informado já pertence a outro usuário.',
                                'Fechar',
                                {
                                    duration: 4000
                                }
                            );
                        } else {
                            this.snackBar.open('Erro ao atualizar usuário.', 'Fechar', {
                                duration: 3000
                            });
                        }
                    }
                });
            }
        });
    }
}
